"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnitSpace = void 0;
var UnitSpace = /** @class */ (function () {
    function UnitSpace() {
        this.propertyUnitId = '';
        this.unitSpaceId = '';
        this.spaceConfigurationId = null;
        this.spaceNumber = '';
        this.mergedUnitSpaceIds = '';
        this.amenityNames = '';
        this.leaseStartDate = null;
        this.availableOn = '';
        this.unitSpaceStatusTypeId = '';
        this.unitNumber = '';
        this.spaceCount = '';
        this.marketRent = '';
        this.customerName = null;
        this.leaseId = null;
        this.spaceConfigurations = [];
        this.unitStatus = '';
        this.unitAmenities = [];
    }
    return UnitSpace;
}());
exports.UnitSpace = UnitSpace;
